export default __webpack_public_path__ + "static/media/chausath-yogini-temple.e1c7005b.jpg";